<template>
   <div>
       <div class="container-fluid">
           <div class="management-services-header">
               <div id="ms-header-bg"></div>
               <div class="header-text">
                   <p>
                   Leveraging our relationships<br>for your benefit.<br>
                   </p>
               </div>
           </div>
           <div class="mobile-img-header">
               <div>
                   <div style="background-image:url('../../public/images/case-study-2.jpg');background-size:cover;background-repeat:no-repeat;width:100%;height:0;padding-top:52vh;position:relative;"></div>
                   <div class="mobile-header-text">
                       <p>
                           Leveraging our relationships<br>for your benefit.<br>
                       </p>
                   </div>
               </div>
           </div>
       </div>
 
       <!-- Case Study 1 Section -->
       <div class="container-fluid cont">
           <div class="package-services-content1">
               <div class="package-services-content1-left">
                   <!-- Desktop Carousel 1 -->
                   <div id="desktop-csholder">
                       <div id="cs-car1">
                           <div id="car-img" class="carousel carousel-fade" data-ride="carousel">
                               <ol class="carousel-indicators">
                                   <!-- <li data-target="#car-img" data-slide-to="0" class="active"></li> -->
                                   <!-- <li data-target="#car-img" data-slide-to="1"></li> -->
                                   <!-- <li data-target="#car-img" data-slide-to="2"></li> -->
                               </ol>
                               <div class="carousel-inner" id="cs1"></div>
                               <!-- <a class="carousel-control-prev" href="#car-img" role="button" data-slide="prev">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/right-arrow.svg" style="width:30px;transform:scaleX(-1);"></span>
                                   <span class="sr-only">Previous</span>
                               </a> -->
                               <!-- <a class="carousel-control-next" href="#car-img" role="button" data-slide="next">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/right-arrow.svg" style="width:30px;"></span>
                                   <span class="sr-only">Next</span>
                               </a> -->
                           </div>
                       </div>
                   </div>
               </div>
               <div class="package-services-content1-right">
                   <div class="cs1t"></div>
                   <!-- <p class="ps-content-title">Case Study</p> -->
                   <!-- Mobile Carousel 1  -->
                   <div id="mobile-csholder"></div>
                   <p class="cs1c"></p>
                   <br>
                   <!-- <p class="cs1cd"><strong>Project Details:</strong><br></p> -->
                   <router-link to="/products" style="display:inline-block;">
                        <div class="btn-group-lg" style="margin-top:40px;">
                            <button type="button" class="btn btn-primary" style="background: #305CA2; border-radius: 10px 0 0 10px; border: none; font-size: 17px; padding: 10px 21px;width: 244px;">View our Full Catalog</button>
                            <button type="button" class="btn btn-primary btn-default btn-sm" style="background: #5d7cad; border-radius: 0 10px 10px 0; border: none; font-size: 17px; padding: 10px 13px"><img src="../../public/images/right-arrow.svg" style="width: 18px;" ></button>
                        </div>
                    </router-link>
                    <br>
                    <router-link to="/profile" style="display:inline-block;" id="csbtn-2">
                        <div class="btn-group-lg" style="margin-top:40px;">
                            <button type="button" class="btn btn-primary" style="background: #305CA2; border-radius: 10px 0 0 10px; border: none; font-size: 17px; padding: 10px 21px;width: 244px;">View our Profile</button>
                            <button type="button" class="btn btn-primary btn-default btn-sm" style="background: #5d7cad; border-radius: 0 10px 10px 0; border: none; font-size: 17px; padding: 10px 13px"><img src="../../public/images/right-arrow.svg" style="width: 18px;" ></button>
                        </div>
                    </router-link>
               </div>
           </div>
       </div>
 
       <!-- <div class="container-fluid casestudy-content2 cont">
           <div class="casestudy-contentbox">
               <div id="desktop-csholder2">
                   <div id="cs-car2">
                       <div id="carouselExampleIndicators2" class="carousel carousel-fade" data-ride="carousel" style="width: 100%; height: 100%; display: block; margin: 0 0 8% 4%; float: right;">
                           <ol class="carousel-indicators">
                               <li data-target="#carouselExampleIndicators2" data-slide-to="0" class="active"></li>
                               <li data-target="#carouselExampleIndicators2" data-slide-to="1"></li>
                           </ol>
                           <div class="carousel-inner">
                               <div class="carousel-item active">
                                   <img class="d-block w-100" src="../../public/images/mobile-casestudy-img1.png" >
                               </div>
                               <div class="carousel-item">
                                   <img class="d-block w-100" src="../../public/images/mobile-casestudy-img2.png">
                               </div>
                           </div>
                           <a class="carousel-control-prev" href="#carouselExampleIndicators2" role="button" data-slide="prev">
                               <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-back-circle.svg" style="width: 30px;"></span>
                               <span class="sr-only">Previous</span>
                           </a>
                           <a class="carousel-control-next" href="#carouselExampleIndicators2" role="button" data-slide="next">
                               <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-forward-circle.svg" style="width: 30px;"></span>
                               <span class="sr-only">Next</span>
                           </a>
                       </div>
                   </div>
               </div>
               <div class="casestudy-contentbox-right">
                   <h2 class="cs-title"><strong>Lorem ipsum dolor sit amet consetetur</strong></h2>
                   <p class="ps-content-title">Case Study 2</p>
                   <div id="mobile-csholder2"></div>
                   <p style="margin-top: 40px;line-height:30px;text-align:justify;font-size:17px;">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p>
               </div>
           </div>
       </div> -->
   </div>
</template>
 
<script>
// import axios from 'axios';
import $ from 'jquery';
 
export default {
   name: "CaseStudy",
   head: {
      script: [
        { type: 'text/javascript', src: 'https://www.googletagmanager.com/gtag/js?id=G-BZSX6TWYZ4', async: true, body: false}, // Insert in bod
      ],
    },
   mounted() {
       this.csData();
       $(function(){
           MoveSearch(x);
       });
       var x = window.matchMedia("(max-width: 900px)")
       x.addListener(MoveSearch)
       function MoveSearch(x) {
           if (x.matches) {
               $('#cs-car1').appendTo('#mobile-csholder');
               // $('#cs-car2').appendTo('#mobile-csholder2');
           } else {
               $('#cs-car1').appendTo('#desktop-csholder');
               // $('#cs-car2').appendTo('#desktop-csholder2');
           }
       }
   },
   methods: {
       csData() {
           var Airtable = require('airtable');
           var base = new Airtable({apiKey: 'patuMyb6fwFAe9THH.ca32f9390ac6213308df3a99dc6fb185f635fe2d42d8020693e93ec6273f6d3f'}).base('appvYrkhR0QLHGIgm');
           base('Case Study').select({
               view: 'Grid view'
           }).firstPage(function(err, records) {
               if (err) { console.error(err); return; }
               records.forEach(function(record) {
                   var csTitle = record.fields.Title;
                   var csText = record.fields.Text.replace(/`/g, '');
                //    var csDetails = record.fields.Details.replace(/`/g, '').replace(/\\/g, '');
                   var csImgs = record.fields.Images;
                   $('.cs1t').prepend('<h2 data-v-8c01f9a2 class="cs-title"><strong>'+ csTitle +'</strong></h2>');
                   $('.cs1c').prepend('<p data-v-8c01f9a2>'+ csText +'</p>');
                //    $('.cs1cd').append('<p data-v-8c01f9a2>'+ csDetails +'</p>');
                   for(var f=0;f<csImgs.length;f++){
                       $("#cs1").append('<div class="carousel-item"><img class="d-block w-100" src="'+csImgs[f].url+'"></div>');
                   }
                   $("#cs1 > div:first-child").addClass("active");
               });
           });
       }
   }
}
 
$(function(){
   MoveSearch(x);
});
 
var x = window.matchMedia("(max-width: 900px)")
x.addListener(MoveSearch)
 
function MoveSearch(x) {
 if (x.matches) {
   $('#cs-car1').appendTo('#mobile-csholder');
   // $('#cs-car2').appendTo('#mobile-csholder2');
 } else {
   $('#cs-car1').appendTo('#desktop-csholder');
   // $('#cs-car2').appendTo('#desktop-csholder2');
 }
}
 

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-BZSX6TWYZ4');

</script>
 
<style scoped>
    * {
       box-sizing: border-box;
       margin: 0;
       padding: 0;
       font-family: 'Forma DJR Micro', sans-serif;
   }
   .carousel-indicators {
       margin-top: 600px;
       bottom: -35px;
   }
   .carousel-indicators li {
       width: 25px;
       height: 4px;
       background-color: #adadad;
   }
   .carousel-indicators .active {
       background-color: #00C5BC;
       width: 36px;
   }
   .cont {
       padding: 0 7% 0 7%;
   }
   .management-services-header {
       background: url("../../public/images/case-study-2.jpg");
       background-size: cover;
       background-repeat: no-repeat;
       width: 100%;
       position: relative;
       background-position-y: -100px;
   }
   #ms-header-bg {
       background-image:url('../../public/images/case-study-2.jpg');
       background-size: cover;
       background-repeat:no-repeat;
       width:100%;
       height:0;
       padding-top:35%;
       position:relative;
       visibility: hidden;
       background-position-y: -100px;
   }
   #header-gDash {
       width:46%;
       max-width:1060px;
       height:3px;
       background:#00C5BC;
       position:absolute;
       bottom:17%;
   }
   .header-text, .mobile-header-text {
       position: absolute;
       top: 0;
       padding: 110px 4% 0 0;
       width: 100%;
   }
   .header-text p {
       color: white;
       font-size: clamp(35px, 3.3vw, 65px);
       line-height: 1.3em;
       font-weight: bold;
       text-align: right;
       text-shadow: 6px 10px 22px black;
   }
   .mobile-header-text p {
       color: white;
       font-size: clamp(20px, 12vw, 50px);
       line-height: 1.3em;
       font-weight: bold;
       text-align: right;
       text-shadow: 6px 10px 22px black;
   }
   .mobile-img-header {
       background: url("../../public/images/case-study-2.jpg") bottom;
       background-size: cover;
       background-repeat: no-repeat;
       width: 100%;
       position: relative;
       display: none;
   }
   .cs-title {
       font-size: 34px;
       line-height: 50px;
   }
   .package-services-content1 {
       margin-top: 6%;
       display: flex;
       justify-content: space-between;
       flex-direction: row;
   }
   .package-services-content1-right {
       padding: 0 0 0 5%;
       width: 60%;
   }
   .package-services-content1-left {
       display:flex;
       justify-content:center;
       flex-direction:column;
   }
   .package-services-content1-right-subbox {
       background: #004884;
       width: 100%;
       padding: 5%;
       color: white;
       font-size: clamp(20px, 1.5vw, 40px);
       font-weight: thin;
       margin: 6% 0 8% 0;
   }
   .casestudy-contentbox {
       width: 100%;
       padding: 6%;
       display: flex;
       justify-content: space-between;
   }
   .casestudy-contentbox-right {
       width: 60%;
       padding-left: 15px;
   }
   .casestudy-content2 {
       padding: 0;
       margin-top: 5%;
       height: 85vh;
       min-height: 600px;
       max-height: 860px;
       background: #EDEDED;
       padding: 1% 1.15%;
       margin-bottom: -20vh;
   }
   #mobile-ps1-img, #mobile-ps2-img {
       width: 80%;
       height: auto;
       display: none;
       margin: 0 0 8% 0%;
   }
   .ps-content-title {
       font-size: clamp(25px, 1.5vw, 30px);
       margin-top: 15px;
   }
   #cs-car1 {
       display: block;
       margin: 0 4% 8% 0;
       align-self: center;
   }
   #cs-car2 {
       height: 100%;
       display: block;
       margin: 0 4% 8% 0%;
   }
   .cs1c {
       margin-top: 40px;
       line-height:32px;
       text-align:justify;
       font-size:17px;
   }
   /* #csbtn-2 { */
        /* margin-left: 15px; */
    /* } */
    @media screen and (max-width: 1246px) {
       /* #csbtn-2 { */
           /* margin-left: 0; */
        /* } */
   }
   @media screen and (max-width: 1200px) {
       #header-gDash {
           width:40%;
       }
   }
   @media screen and (max-width: 1100px) {
       #header-gDash {
           width:36%;
       }
   }
   @media screen and (max-width: 1000px) {
       #header-gDash {
           width:31%;
       }
   }
   @media screen and (max-width: 900px) {
       .cont {
           padding: 0 50px 0 50px;
       }
       .cs1t {
           padding-bottom: 40px;
       }
       .management-services-header, #package-services-content1-img {
           display: none;
       }
       .mobile-img-header, #mobile-package-content {
           display: block;
       }
       #mobile-ps1-img, #mobile-ps2-img {
           display: block;
           width: 100%;
       }
       .package-services-content1-right {
           width: 100%;
           padding: 40px 0;
       }
       .ps-content-title {
           padding: 0px 0 40px 0;
       }
       .casestudy-contentbox {
           padding: 11% 0 11% 0;
       }
       .casestudy-contentbox-left {
           display: none;
       }
       .casestudy-contentbox-right {
           width: 100%;
       }
       .casestudy-content2 {
           height: auto;
           min-height: unset;
           max-height: unset;
           margin-bottom: 0;
           padding-bottom: 55px;
       }
       #cs-car1, #cs-car2 {
           margin: 0;
       }
       #car-img {
           margin-bottom: 50px;
       }
        .header-text, .mobile-header-text {
            padding: 100px 4% 0 0;
        }
        .mobile-header-text p {
            font-size: clamp(20px,7vw,40px);
        }
   }
   @media screen and (max-width: 500px) {
       .cont {
           padding: 0 20px 0 20px;
       }
       .mobile-img-header {
           max-height:335px;
       }
       #mobile-about-header {
           font-size: 24px;
           line-height: unset;
       }
       .mobile-header-text p {
           font-size: clamp(25px,6.4vw,35px);
       }
       .cs-title {
           font-size: 28px;
           line-height: 38px;
       }
       .casestudy-contentbox {
           padding: 50px 0;
       }
       .casestudy-contentbox-right {
           padding-left: 0;
       }
       .cs1c {
           line-height:30px;
           font-size:16px;
       }
   }
   @media screen and (max-width: 335px) {
       .mobile-header-text p {
           font-size: 24px;
           line-height: 1.25em;
       }
   }
</style>

